import PropTypes from "prop-types"
import React, { forwardRef, Fragment, useImperativeHandle } from "react"
import { Box } from "@material-ui/core"
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { CircularProgress } from "../../../../../../node_modules/@material-ui/core/index"
import { openSnackBar } from "../../../../../actions/snack-bar"

const CheckoutForm = forwardRef(({ buttonRef, setLoading }) => {
  const stripe = useStripe()
  const elements = useElements()

  useImperativeHandle(buttonRef, () => ({
    handleSubmit(event) {
      // debugger;
      return new Promise((resolve, reject) => {
        if (!stripe || !elements) {
          // Stripe.js has not yet loaded.
          // Make sure to disable form submission until Stripe.js has loaded.
          setLoading(false)
          openSnackBar({ message: "Error submitting payment" })
          return
        }

        stripe
          .confirmPayment({
            redirect: "if_required",
            //`Elements` instance that was used to create the Payment Element
            elements,
          })
          .then(res => {
            if (res.error) {
              setLoading(false)
              reject(res)
            } else {
              resolve(res)
            }
          })
          .catch(err => {
            openSnackBar({ message: "Error submitting payment" })

            setLoading(false)
            reject(err)
          })
      })
    },
  }))

  return (
    <Box>
      {PaymentElement ? (
        <Fragment>
          <PaymentElement />
        </Fragment>
      ) : (
        <CircularProgress />
      )}
    </Box>
  )
})

CheckoutForm.propTypes = {
  children: PropTypes.node,
}

export default CheckoutForm
